import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { useResponsiveInfo } from '../../hooks/useResponsiveInfo'
import { makeStyles } from 'tss-react/mui'

export type CircularProgressWithLabelProps = {
  label: string
  progress: number
}

export const useStyles = makeStyles()(theme => ({
  outerContainer: {
    padding: '5px',
    display: '-webkit-flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  innerContainer: {
    position: 'relative',
    display: 'inline-flex'
  },
  loader: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loaderPercentageLabel: {
    fontWeight: 'bold',
    fontSize: '0.7rem',
    variant: 'caption',
    color: 'text.secondary',
  },
  loaderLabel: {
    paddingTop: '5px',
    letterSpacing: 0.25
  },
}))

const CircularProgressWithLabel = (props: CircularProgressWithLabelProps) => {
  const { label, progress } = props
  const { isMobile } = useResponsiveInfo()
  const { classes } = useStyles()

  return (
    <Box className={classes.outerContainer}>
      <Box className={classes.innerContainer}>
        <CircularProgress size={'2.5rem'} variant={'determinate'} value={progress} />
        <Box className={classes.loader}>
          <Typography className={classes.loaderPercentageLabel}>
            {`${progress}%`}
          </Typography>
        </Box>
      </Box>
      <Typography
        className={classes.loaderLabel}
        fontSize={isMobile ? '0.8rem' : '1rem'}
      >
        {label}
      </Typography>
    </Box>
  )
}

export default CircularProgressWithLabel
